"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PriceUnit;
(function (PriceUnit) {
    PriceUnit["EUR_PER_M3"] = "\u20AC/m3";
    PriceUnit["EUR_PER_DAY"] = "\u20AC/dag";
    PriceUnit["EUR_PER_KWH"] = "\u20AC/kWh";
    PriceUnit["PERCENTAGE"] = "%";
    PriceUnit["EUR"] = "\u20AC";
})(PriceUnit || (PriceUnit = {}));
exports.default = PriceUnit;
